var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('t-page',[_c('t-page-report',{attrs:{"reportId":22,"type":"D"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }